import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", null, "beta", -1)
const _hoisted_3 = {
  role: "main",
  class: "mt-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Wecome to the WorldWide Telescope embed creator tool! This site helps you create HTML code that you can use to embed WWT in your own websites. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Mode", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " WWT offers several view modes. Click one of the tabs at the top, or one of the following links: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Global Settings", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-4" }, "Custom Data Loading", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" WWT can showcase an image of your choosing. In order to do so, it has to be told both where to find the image data "),
  /*#__PURE__*/_createElementVNode("b", null, "and"),
  /*#__PURE__*/_createTextVNode(" where the image should be placed on the sky. Different web services can analyze images to extract the necessary information. "),
  /*#__PURE__*/_createElementVNode("i", null, "Choose one of the follow tabs for instructions"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://astropix.ipac.caltech.edu/" }, "AstroPix"),
  /*#__PURE__*/_createTextVNode(" from "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.ipac.caltech.edu/" }, "IPAC"),
  /*#__PURE__*/_createTextVNode(" collects astronomical imagery from observatories across the world and in space. To embed an image from AstroPix:")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Navigate to the AstroPix page for the image you want, with a URL looking like: "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://astropix.ipac.caltech.edu/image/eso/potw2003a" }, "https://astropix.ipac.caltech.edu/image/..."),
    /*#__PURE__*/_createTextVNode(". (Click the link for a sample.)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("In the “View Options” section at the top-right, find the link labeled “View in WorldWide Telescope”. "),
    /*#__PURE__*/_createElementVNode("i", null, "If you don’t see such a link, the image doesn’t come tagged with enough positional information to be shown in WWT"),
    /*#__PURE__*/_createTextVNode(", unfortunately.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Copy the URL of that WWT link. In most browsers, you should right- or control-click the link and select the menu item labeled something like “Copy Link Location”."),
  /*#__PURE__*/_createElementVNode("li", null, "Paste the WWT URL in the box below!")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "http://nova.astrometry.net/" }, "Astrometry.net"),
  /*#__PURE__*/_createTextVNode(" is a brilliant service that can derive astrometric solutions for sky images even if they’re completely unlabeled. To embed an image from Astrometry.net:")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Navigate to the page for the image you want, with a URL looking like: "),
    /*#__PURE__*/_createElementVNode("a", { href: "http://nova.astrometry.net/user_images/3437740" }, "http://nova.astrometry.net/user_images/..."),
    /*#__PURE__*/_createTextVNode(". (Click the link for a sample.)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "In the “Calibration” section to the right, find the link labeled “view in WorldWide Telescope”."),
  /*#__PURE__*/_createElementVNode("li", null, "Copy the URL of that WWT link. In most browsers, you should right- or control-click the link and select the menu item labeled something like “Copy Link Location”."),
  /*#__PURE__*/_createElementVNode("li", null, "Paste the WWT URL in the box below!")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("The "),
  /*#__PURE__*/_createElementVNode("a", { href: "http://www.astroexplorer.org/" }, "Astronomy Image Explorer"),
  /*#__PURE__*/_createTextVNode(" (AIE) is a comprehensive database of images published in the astronomical research literature. That database includes images of the sky with the coordinate information needed to display in WWT.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("To search for a usable image from "),
    /*#__PURE__*/_createElementVNode("a", { href: "http://www.astroexplorer.org/" }, "the AIE homepage"),
    /*#__PURE__*/_createTextVNode(", click the “Images with astrometry” selector in the “Content Type” section of search filters in the left-hand column.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Navigate to the page for the image you want, with a URL looking like: "),
    /*#__PURE__*/_createElementVNode("a", { href: "http://www.astroexplorer.org/details/308158864287067800170087_0002101.000/eyJjb250ZW50VHlwZXMiOlsiSW1hZ2VzIl0sImFzdHJvbWV0cmljYWxseVRhZ2dlZCI6dHJ1ZSwicGFnZSI6MSwic2hvdyI6MjV9" }, "http://www.astroexplorer.org/details/..."),
    /*#__PURE__*/_createTextVNode(". (Click the link for a sample.)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Find the button link labeled “View in WWT” in the header."),
  /*#__PURE__*/_createElementVNode("li", null, "Copy the URL of that WWT link. In most browsers, you should right- or control-click the link and select the menu item labeled something like “Copy Link Location”."),
  /*#__PURE__*/_createElementVNode("li", null, "Paste the WWT URL in the box below!")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If you know what you’re doing — show an image from a "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://docs.worldwidetelescope.org/data-guide/1/data-file-formats/collections/" }, "WTML collection"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://docs.worldwidetelescope.org/user-manual/1/guidedtours/" }, "Guided Tours"),
  /*#__PURE__*/_createTextVNode(" are scripted, multimedia experiences that guide the viewer through WWT’s simulated universe. If you have a tour file (extension "),
  /*#__PURE__*/_createElementVNode("code", null, ".wtt"),
  /*#__PURE__*/_createTextVNode(") available somewhere online, you can create a WWT embed that plays it automatically. ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Looking for a sample? Copy and paste "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://data1.wwtassets.org/packages/2020/06_ngc6441/NGC6441.WTT" }, "this link URL"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " In this mode, the user can explore a spherical body shown in isolation: no surrounding stars or other planets. ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, "Settings", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, "Preview", -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " Cannot preview because your browser does not support iframes. ", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", null, "Embed Code", -1)
const _hoisted_27 = { class: "mt-2 d-flex align-items-center" }
const _hoisted_28 = { class: "mt-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("code", null, "style", -1)
const _hoisted_30 = { class: "mt-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("code", null, ".wwt-embed { width: 100%; height: 360px; }", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("footer", { class: "text-muted mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "float-right" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Back to top")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Copyright 2023 "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://worldwidetelescope.org/home/",
      target: "_blank"
    }, "WWT contributors"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_b_navbar_toggle = _resolveComponent("b-navbar-toggle")!
  const _component_b_nav_item = _resolveComponent("b-nav-item")!
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_form_radio = _resolveComponent("b-form-radio")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_container, null, {
      default: _withCtx(() => [
        _createElementVNode("header", null, [
          _createVNode(_component_b_navbar, {
            toggleble: "lg",
            variant: "info",
            type: "dark",
            sticky: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_navbar_brand, { href: "#" }, {
                default: _withCtx(() => [
                  _createTextVNode("WWT Embed Creator — "),
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_b_navbar_toggle, { target: "nav-collapse" }),
              _createVNode(_component_b_collapse, {
                id: "nav-collapse",
                "is-nav": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_navbar_nav, { class: "ml-auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_nav_item, { href: "https://worldwidetelescope.org/home/" }, {
                        default: _withCtx(() => [
                          _createTextVNode("WWT Home")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("main", _hoisted_3, [
          _createVNode(_component_b_tabs, {
            "no-fade": "",
            "content-class": "mt-3",
            modelValue: _ctx.currentTabIndex,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.currentTabIndex) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_tab, {
                title: "Home",
                active: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTabIndex = 1))
                      }, "Show an Image")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTabIndex = 2))
                      }, "Play a Guided Tour")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTabIndex = 3))
                      }, "View a Planetary Body")
                    ])
                  ]),
                  _hoisted_7,
                  _createVNode(_component_b_form_group, { label: "Here are some generic settings that you can alter:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.qsb.s.showCrosshairs,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.qsb.s.showCrosshairs) = $event)),
                        name: "crosshairs-checkbox"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Show crosshairs in view center")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.qsb.s.showCoordinateReadout,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.qsb.s.showCoordinateReadout) = $event)),
                        name: "coordinate-readout-checkbox"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Show coordinate readout")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.qsb.s.creditMode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.qsb.s.creditMode) = $event)),
                        name: "credit-mode-checkbox",
                        value: _ctx.CreditMode.Default,
                        "unchecked-value": _ctx.CreditMode.None
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Show “Powered by” credit overlay")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value", "unchecked-value"]),
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.suggestDefaultStyling,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.suggestDefaultStyling) = $event)),
                        name: "default-styling-checkbox"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Include CSS style suggestion in sample embed code")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_8,
                  _createVNode(_component_b_form_group, { label: "URL of additional WTML collection to load:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_input, {
                        modelValue: _ctx.qsb.s.wtmlUrl,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.qsb.s.wtmlUrl) = $event)),
                        name: "wtml-input",
                        type: "url",
                        placeholder: "https://example.com/data.wtml"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "Show an Image" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createVNode(_component_b_tabs, {
                    "no-fade": "",
                    class: "ml-4 mr-4",
                    "content-class": "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_tab, {
                        title: "AstroPix",
                        active: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11,
                          _createVNode(_component_b_form_group, { label: "“View in WorldWide Telescope” link URL:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                name: "img-astropix-showimage-url-input",
                                type: "url",
                                state: _ctx.showImageUrlValidity,
                                onInput: _ctx.onShowImageUrlInput,
                                placeholder: "http://www.worldwidetelescope.org/wwtweb/ShowImage.aspx?..."
                              }, null, 8, ["state", "onInput"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_tab, { title: "Astrometry.net" }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _hoisted_13,
                          _createVNode(_component_b_form_group, { label: "“View in WorldWide Telescope” link URL:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                name: "img-astrometry-showimage-url-input",
                                type: "url",
                                state: _ctx.showImageUrlValidity,
                                onInput: _ctx.onShowImageUrlInput,
                                placeholder: "http://www.worldwidetelescope.org/wwtweb/ShowImage.aspx?..."
                              }, null, 8, ["state", "onInput"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_tab, { title: "Astronomy Image Explorer" }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _hoisted_15,
                          _createVNode(_component_b_form_group, { label: "“View in WWT link URL:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                name: "img-aie-showimage-url-input",
                                type: "url",
                                state: _ctx.showImageUrlValidity,
                                onInput: _ctx.onShowImageUrlInput,
                                placeholder: "http://www.worldwidetelescope.org/wwtweb/ShowImage.aspx?..."
                              }, null, 8, ["state", "onInput"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_tab, { title: "Manual WTML Specification" }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createVNode(_component_b_form_group, { label: "WTML collection URL:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.qsb.s.wtmlUrl,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.qsb.s.wtmlUrl) = $event)),
                                name: "img-wtml-input",
                                type: "url",
                                placeholder: "https://example.com/data.wtml"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_b_form_group, { label: "Imageset name inside WTML:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.qsb.s.foregroundImagesetName,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.qsb.s.foregroundImagesetName) = $event)),
                                name: "img-imgsetname-input",
                                type: "text",
                                placeholder: "My Image Name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_b_form_group, { label: "Place inside WTML:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.qsb.s.wtmlPlace,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.qsb.s.wtmlPlace) = $event)),
                                name: "img-placename-input",
                                type: "text",
                                placeholder: "My Place Name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "Play a Guided Tour" }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18,
                  _createVNode(_component_b_form_group, { label: "Tour URL:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_input, {
                        name: "img-tour-url-input",
                        type: "url",
                        modelValue: _ctx.qsb.s.tourUrl,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.qsb.s.tourUrl) = $event)),
                        placeholder: "https://example.com/tour.wtt"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "View a Planetary Body" }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_b_form_group, {
                    label: "Imagery selection:",
                    "label-cols": "2",
                    "label-class": "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Sun
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sun")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Mercury
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mercury")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Venus
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Venus")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Earth
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Earth")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Moon,
                        class: "pl-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Moon")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Mars
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mars")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Jupiter
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Jupiter")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Io,
                        class: "pl-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Io")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Europa,
                        class: "pl-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Europa")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Ganymede,
                        class: "pl-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ganymede")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Callisto,
                        class: "pl-5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Callisto")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Saturn
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Saturn")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Uranus
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Uranus")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Neptune
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Neptune")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"]),
                      _createVNode(_component_b_form_radio, {
                        modelValue: _ctx.qsb.planetaryBody,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.qsb.planetaryBody) = $event)),
                        name: "planetary-imagery",
                        value: _ctx.PlanetaryBodies.Pluto
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Pluto")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_21,
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createElementVNode("iframe", {
                    src: _ctx.iframeSource,
                    class: "w-100 wwt-preview",
                    allow: "accelerometer; autoplay; clipboard-write; gyroscope",
                    allowfullscreen: ""
                  }, _hoisted_25, 8, _hoisted_23),
                  _createVNode(_component_b_button, {
                    variant: "primary",
                    class: "mt-2",
                    href: _ctx.iframeSource,
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Open Preview in New Window "),
                      _createVNode(_component_font_awesome_icon, { icon: "external-link-alt" })
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _hoisted_26,
                  _createVNode(_component_b_form_textarea, {
                    readonly: "",
                    id: "embed-code-textarea",
                    modelValue: _ctx.embedCode,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.embedCode) = $event)),
                    rows: "5"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_b_button, {
                      variant: "primary",
                      onClick: _ctx.copyToClipboard
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Copy to Clipboard")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-2", { 'fade-out': _ctx.clipboardNoticeFadeOut }]),
                      id: "clipboard-notice"
                    }, _toDisplayString(_ctx.clipboardNoticeText), 3)
                  ]),
                  _withDirectives(_createElementVNode("p", _hoisted_28, [
                    _createTextVNode(" You should apply CSS "),
                    _hoisted_29,
                    _createTextVNode(" settings to control the size of the iframe. The settings suggested above can safely be changed. ")
                  ], 512), [
                    [_vShow, _ctx.suggestDefaultStyling]
                  ]),
                  _withDirectives(_createElementVNode("p", _hoisted_30, [
                    _createTextVNode(" You will need to add appropriate CSS to control the size of the iframe. For instance: "),
                    _hoisted_31
                  ], 512), [
                    [_vShow, !_ctx.suggestDefaultStyling]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_32
      ]),
      _: 1
    })
  ]))
}